<div *ngIf="globalFilterService.networkAccessWarningVisible()">
  <b>Warning:</b> You do not have access to any manufacturing networks for the selected scenario. Please switch to a scenario where you have manufacturing network access or contact
  your admin to request access.
</div>
<div class="py-2" *ngIf="manufacturingFilters">
  <form [formGroup]="filterForm" class="filter-wrapper">
    <div *ngIf="isKPIModeToggleVisible" class="d-flex">
      <mat-button-toggle-group class="supply-mode-toggle" [ngModel]="kpi_screen" (ngModelChange)="onKpiScreenChange($event)" [ngModelOptions]="{ standalone: true }">
        <mat-button-toggle
          *ngFor="let param of kpiScreenParam"
          [ngClass]="param.isDisabled ? 'disable' : ''"
          [value]="param.key"
          [disabled]="param.isDisabled"
          [attr.title]="param.isDisabled ? 'Access Restricted' : ''"
          >{{ param.description }}</mat-button-toggle
        >
      </mat-button-toggle-group>
      <div class="dashboardseparator"></div>
    </div>
    <!-- <div *ngIf="isSupplyModeToggleVisible">
      <mat-button-toggle-group class="supply-mode-toggle" [ngModel]="supply_mode" (ngModelChange)="onSupplyModeChange($event)" [ngModelOptions]="{ standalone: true }">
        <mat-button-toggle
          *ngFor="let param of supplyModeParam"
          [ngClass]="param.isDisabled ? 'disable' : ''"
          [value]="param.key"
          [disabled]="param.isDisabled"
          [attr.title]="param.isDisabled ? 'Access Restricted' : ''"
          >{{ param.description }}</mat-button-toggle
        >
      </mat-button-toggle-group>
    </div> -->
    <div *ngIf="isInsightToggleVisible" class="d-flex">
      <mat-button-toggle-group class="supply-mode-toggle" [ngModel]="insight_mode" (ngModelChange)="onInsightModeChange($event)" [ngModelOptions]="{ standalone: true }">
        <mat-button-toggle
          *ngFor="let param of insightScreenParam"
          [ngClass]="param.isDisabled ? 'disable' : ''"
          [value]="param.key"
          [disabled]="param.isDisabled"
          [attr.title]="param.isDisabled ? 'Access Restricted' : ''"
          >{{ param.description }}</mat-button-toggle
        >
      </mat-button-toggle-group>
      <div class="dashboardseparator"></div>
    </div>
    <!-- <div class="separator" *ngIf="isSupplyModeToggleVisible && !isKPIModeToggleVisible"></div> -->
    <mat-form-field *ngIf="mapViewScreen" floatLabel="always">
      <mat-label class="custom-mat-label">Geography</mat-label>
      <mat-select
        [class.expanded]="filterIconFlag?.['geography']"
        ngDefaultControl
        (openedChange)="handleOpenedChange($event, 'geography')"
        formControlName="geography"
        multiple
        [panelClass]="'global-custom-select'"
        placeholder="Select Geography"
        [formControl]="manufacturingFilters.geography.formControl"
      >
        <mat-option>
          <ngx-mat-select-search
            [formControl]="manufacturingFilters.geography.filterCtrl"
            noEntriesFoundLabel="No entries found"
            closeIcon="x"
            placeholderLabel="Search"
          ></ngx-mat-select-search>
        </mat-option>
        <mat-option #allSelectedgeography (click)="toggleAllSelection('geography', allSelectedgeography)" [value]="''"> Select All </mat-option>

        <mat-option *ngFor="let type of manufacturingFilters.geography.filtered | async" (click)="togglePerOne('geography', allSelectedgeography)" [value]="type">{{
          type
        }}</mat-option>
      </mat-select>
    </mat-form-field>
    <!-- <mat-form-field *ngIf="supply_mode == 'manufacturing' && !isKPIModeToggleVisible" floatLabel="always">
      <mat-label class="custom-mat-label">Internal/Venture</mat-label>
      <div class="d-flex">
        <mat-select
          [class.expanded]="filterIconFlag?.['firm_type']"
          ngDefaultControl
          (openedChange)="handleOpenedChange($event, 'firm_type')"
          formControlName="firm_type"
          multiple
          panelClass="custom-dropdown-arrow"
          [panelClass]="'global-custom-select'"
          placeholder="Select Mondelez/Venture"
          [formControl]="manufacturingFilters.firm_type.formControl"
        >
          <mat-option>
            <ngx-mat-select-search
              [formControl]="manufacturingFilters.firm_type.filterCtrl"
              noEntriesFoundLabel="No entries found"
              closeIcon="x"
              placeholderLabel="Search"
            ></ngx-mat-select-search>
          </mat-option>
          <mat-option #allSelectedFirm (click)="toggleAllSelection('firm_type', allSelectedFirm)" [value]="''"> Select All </mat-option>
          <mat-option *ngFor="let type of manufacturingFilters.firm_type.filtered | async" (click)="togglePerOne('firm_type', allSelectedFirm)" [value]="type">{{
            type
          }}</mat-option>
        </mat-select>
        <span *ngIf="clearFirmType" class="cross-mark" (click)="clearSelection($event)">✕</span>
      </div>
    </mat-form-field> -->
    <mat-form-field *ngIf="supply_mode == 'manufacturing' || isInsightModeActive()" floatLabel="always">
      <mat-label class="custom-mat-label">Category</mat-label>
      <mat-select
        [class.expanded]="filterIconFlag?.['category']"
        ngDefaultControl
        (openedChange)="handleOpenedChange($event, 'category')"
        formControlName="category"
        multiple
        [panelClass]="'global-custom-select'"
        placeholder="Select Category"
        [formControl]="manufacturingFilters.category.formControl"
      >
        <mat-option>
          <ngx-mat-select-search
            [formControl]="manufacturingFilters.category.filterCtrl"
            noEntriesFoundLabel="No entries found"
            closeIcon="x"
            placeholderLabel="Search"
          ></ngx-mat-select-search>
        </mat-option>
        <mat-option #allSelectedCategpry (click)="toggleAllSelection('category', allSelectedCategpry)" [value]="''"> Select All </mat-option>

        <mat-option *ngFor="let type of manufacturingFilters.category.filtered | async" (click)="togglePerOne('category', allSelectedCategpry)" [value]="type">{{
          type
        }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field *ngIf="supply_mode == 'manufacturing' || isInsightModeActive()" floatLabel="always">
      <mat-label class="custom-mat-label">Brand</mat-label>
      <mat-select
        [class.expanded]="filterIconFlag?.['brand']"
        ngDefaultControl
        (openedChange)="handleOpenedChange($event, 'brand')"
        formControlName="brand"
        multiple
        [panelClass]="'global-custom-select'"
        placeholder="Select Brand"
        [formControl]="manufacturingFilters.brand.formControl"
      >
        <mat-option>
          <ngx-mat-select-search
            [formControl]="manufacturingFilters.brand.filterCtrl"
            noEntriesFoundLabel="No entries found"
            closeIcon="x"
            placeholderLabel="Search"
          ></ngx-mat-select-search>
        </mat-option>
        <mat-option #allSelectedB (click)="toggleAllSelection('brand', allSelectedB)" [value]="''">Select All </mat-option>
        <mat-option *ngFor="let type of manufacturingFilters.brand.filtered | async" (click)="togglePerOne('brand', allSelectedB)" [value]="type">{{ type }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field *ngIf="supply_mode == 'manufacturing' || isInsightModeActive()" floatLabel="always">
      <mat-label class="custom-mat-label">Manufacturing Networks</mat-label>
      <mat-select
        [class.expanded]="filterIconFlag?.['manufacturing_network']"
        ngDefaultControl
        (openedChange)="handleOpenedChange($event, 'manufacturing_network')"
        formControlName="manufacturing_network"
        multiple
        [panelClass]="'global-custom-select'"
        placeholder="Select Manufacturing Networks"
        [formControl]="manufacturingFilters.manufacturing_network.formControl"
      >
        <mat-option>
          <ngx-mat-select-search
            [formControl]="manufacturingFilters.manufacturing_network.filterCtrl"
            noEntriesFoundLabel="No entries found"
            closeIcon="x"
            placeholderLabel="Search"
          ></ngx-mat-select-search>
        </mat-option>
        <mat-option #allSelectedNetwork (click)="toggleAllSelection('manufacturing_network', allSelectedNetwork)" [value]="''">Select All </mat-option>
        <mat-option
          *ngFor="let type of manufacturingFilters.manufacturing_network.filtered | async"
          (click)="togglePerOne('manufacturing_network', allSelectedNetwork)"
          [value]="type"
          >{{ type }}</mat-option
        >
      </mat-select>
    </mat-form-field>
    <mat-form-field *ngIf="supply_mode === 'logistics'" floatLabel="always">
      <mat-label class="custom-mat-label">Type</mat-label>
      <mat-select
        [class.expanded]="filterIconFlag?.['node_type']"
        ngDefaultControl
        (openedChange)="handleOpenedChange($event, 'node_type')"
        formControlName="node_type"
        multiple
        [panelClass]="'global-custom-select'"
        placeholder="Select Type"
        [formControl]="nodeFilters.node_type.formControl"
      >
        <mat-option>
          <ngx-mat-select-search
            [formControl]="nodeFilters.node_type.filterCtrl"
            noEntriesFoundLabel="No entries found"
            closeIcon="x"
            placeholderLabel="Search"
          ></ngx-mat-select-search>
        </mat-option>
        <mat-option #allSelectednode_type (click)="toggleAllSelection('node_type', allSelectednode_type)" [value]="''"> Select All </mat-option>
        <mat-option *ngFor="let type of nodeFilters.node_type.filtered | async" (click)="togglePerOne('node_type', allSelectednode_type)" [value]="type">{{ type }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field *ngIf="supply_mode == 'logistics'" floatLabel="always">
      <mat-label class="custom-mat-label">Location</mat-label>
      <mat-select
        [class.expanded]="filterIconFlag?.['node_code']"
        ngDefaultControl
        (openedChange)="handleOpenedChange($event, 'node_code')"
        formControlName="node_code"
        multiple
        [panelClass]="'global-custom-select'"
        [placeholder]="'Select Location'"
        [formControl]="nodeFilters.node_code.formControl"
      >
        <mat-option>
          <ngx-mat-select-search
            [formControl]="nodeFilters.node_code.filterCtrl"
            noEntriesFoundLabel="No entries found"
            closeIcon="x"
            placeholderLabel="Search"
          ></ngx-mat-select-search>
        </mat-option>
        <mat-option #allSelectednode_code (click)="toggleAllSelection('node_code', allSelectednode_code)" [value]="''"> Select All </mat-option>
        <mat-option *ngFor="let type of nodeFilters.node_code.filtered | async" (click)="togglePerOne('node_code', allSelectednode_code)" [value]="type">{{ type }}</mat-option>
      </mat-select>
    </mat-form-field>
    <!-- <mat-form-field *ngIf="supply_mode !== 'logistics' && isKPIModeToggleVisible" floatLabel="always">
      <mat-label class="custom-mat-label">Plant</mat-label>
      <mat-select
        [class.expanded]="filterIconFlag?.['plant_code']"
        ngDefaultControl
        (openedChange)="handleOpenedChange($event, 'plant_code')"
        formControlName="plant_code"
        multiple
        [panelClass]="'global-custom-select'"
        [placeholder]="'Select Plant'"
        [formControl]="nodeFilters.plant_code.formControl"
      >
        <mat-option>
          <ngx-mat-select-search
            [formControl]="nodeFilters.plant_code.filterCtrl"
            noEntriesFoundLabel="No entries found"
            closeIcon="x"
            placeholderLabel="Search"
          ></ngx-mat-select-search>
        </mat-option>
        <mat-option #allSelectedplant_code (click)="toggleAllSelection('plant_code', allSelectedplant_code)" [value]="''"> Select All </mat-option>
        <mat-option *ngFor="let type of nodeFilters.plant_code.filtered | async" (click)="togglePerOne('plant_code', allSelectedplant_code)" [value]="type">{{ type }}</mat-option>
      </mat-select>
    </mat-form-field> -->

    <div class="d-flex align-items-baseline">
      <app-year-picker *ngIf="masterData" [startYear]="historicalStartYear" [endYear]="masterData?.end_year" (yearsSelected)="onYearsSelected($event)"></app-year-picker>
      <button class="mdlz-btn-clear" (click)="onClearFilter()">Clear All</button>
    </div>
  </form>
</div>
